import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { LinkCard } from 'components/Card';
import { useAuth } from 'contexts/auth-context';
import { useTranslation } from 'contexts/translation-context';

export const CarrierSelectionPage = () => {
  const { me } = useAuth();
  const navigate = useNavigate();
  const { i18n } = useTranslation();

  useEffect(() => {
    if (me.carriers.length === 1) {
      navigate(`/carrier-portal/${me.carriers[0].id}`, { replace: true });
    }
  }, [me, navigate]);

  return (
    <main className="content-bg min-h-screen p-8">
      <h1 className="heading-one mb-6">{i18n('carrierPortal.selectCarrier')}</h1>

      <div className="grid grid-cols-3 gap-4">
        {me.carriers.map((carrier) => {
          return <LinkCard key={carrier.id} to={`/carrier-portal/${carrier.id}`} title={carrier.name} content={null} />;
        })}
      </div>
    </main>
  );
};
